// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"building-2"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 21V9H3V21H21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 9V4.4L12 2L16 4.4V9H8Z"}}]},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 14H9V21H15V14Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M12 5.99805H12.0039V6.00195H12V5.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15 14H9V21H15V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 5L12 2L17 5M8 4.9V9M16 4.9V9M21 9V21H3V9H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Building2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-2',
    ref,
    icon: element,
  },
));

Building2Icon.displayName = 'Building2Icon';

export default Building2Icon;
